
module.exports.createVoucherQRCode = function(voucherId)
{
    return `com.flipdish.qr.voucher.${voucherId}`;
}